module.exports = __webpack_public_path__ + "static/spaghetti-e38ad438ea05e0ab406402b8b929590b.jpg";